import { UserLog } from '@/utils/log'
import Service from '@/service/public'
import { App_User } from '@/data/user_info'
export default {
    methods: {
        callConsultant (e, tip_content) {
            const { id } = e.target.dataset
            this.callConsultantById(id, tip_content)
        },
        callConsultantById (id, tip_content) {
            App_User.get().then((data) => {
                if (this.is_index && data.tag_list && data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    this.$showCallModal(() => {
                        Service.getPhonePosition({
                            consultant_id: id
                        }).then(({ phone }) => {
                            this.$wx.makePhoneCall({
                                phoneNumber: phone,
                                success: () => {}
                            })
                            UserLog.callConsultant(id)
                        })
                    }, '置业顾问名牌——电话拨打', tip_content)
                }
            })
        }
    }
}
